import { createFileRoute } from "@tanstack/react-router";
import { LegalLayout } from "@/components/LegalLayout";
import { useLocale } from "@/contexts/LocaleContext";
import { DICTS } from "@/lib/i18n";
import { PUBLIC_SITE_ORIGIN } from "@/lib/public-origin";

import { publicCacheHeaders } from "@/lib/public-cache-headers";

export const Route = createFileRoute("/copyright")({
  headers: publicCacheHeaders,
  head: () => ({
    meta: [
      { title: DICTS.en["legal.copyright.meta.title"] },
      { name: "description", content: DICTS.en["legal.copyright.meta.description"] },
      { property: "og:title", content: DICTS.en["legal.copyright.meta.title"] },
      { property: "og:description", content: DICTS.en["legal.copyright.meta.description"] },
      { property: "og:url", content: `${PUBLIC_SITE_ORIGIN}/copyright` },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: `${PUBLIC_SITE_ORIGIN}/copyright` }],
  }),
  component: CopyrightPage,
});

function CopyrightPage() {
  const { t } = useLocale();
  return (
    <LegalLayout titleKey="legal.copyright.title" eyebrowKey="legal.copyright.eyebrow">
      <p>{t("legal.copyright.intro")}</p>
      <h2>{t("legal.copyright.h2_owned")}</h2>
      <p>{t("legal.copyright.p_owned")}</p>
      <h2>{t("legal.copyright.h2_ambassadors")}</h2>
      <p>{t("legal.copyright.p_ambassadors")}</p>
      <h2>{t("legal.copyright.h2_forbidden")}</h2>
      <p>{t("legal.copyright.p_forbidden")}</p>
      <h2>{t("legal.copyright.h2_report")}</h2>
      <p>{t("legal.copyright.p_report")}</p>
    </LegalLayout>
  );
}
